// GraphQL API configuration
export const API_CONFIG = {
  endpoint: import.meta.env.VITE_API_URL || 'http://localhost:3333/graphql',
  headers: {
    'Content-Type': 'application/json',
  },
} as const;

// Auth configuration
export const AUTH_CONFIG = {
  tokenKey: 'recop_auth_token',
  refreshTokenKey: 'recop_refresh_token',
} as const;
